import { Component, Input } from '@angular/core';
import {
  StudentClassListItemDTO,
  IStudentClassListItemDTO,
} from '@models/student-classroom';

@Component({
  selector: 'app-shared-classroom-card-presentation',
  templateUrl: './classroom-card-presentation.component.html',
  styleUrls: ['./classroom-card-presentation.component.scss'],
})
export class ClassroomCardPresentationComponent {
  @Input() classListItem: IStudentClassListItemDTO =
    new StudentClassListItemDTO();
  @Input() route: string = '';
  @Input() canNavigate: boolean = true;
}
